'use client';

import { StaticPageHeader } from './StaticPageHeader';
import { StaticPageFooter } from './StaticPageFooter';
// import { Breadcrumbs } from './Breadcrumbs';

interface StaticPageLayoutProps {
  children: React.ReactNode;
}

export default function StaticPageLayout({ children }: StaticPageLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col">
      <StaticPageHeader />
      {/* <Breadcrumbs /> */}
      {children}
      <StaticPageFooter />
    </div>
  );
}
